import { FETCH_VIDEOS } from './constants'

export const fetchVideos = {
  request: currentPhoneId => ({
    type: FETCH_VIDEOS['REQUEST'],
    currentPhoneId
  }),
  success: (videos, currentPhoneId) => ({
    type: FETCH_VIDEOS['SUCCESS'],
    videos,
    currentPhoneId
  })
}



// WEBPACK FOOTER //
// ./src/containers/Videos/actions.js